<template>
    <div>
        <v-data-table
            :headers="headers"
            :items="workOrdersFiltered"
            class="elevation-0"
            :mobile-breakpoint="0"
            :loading="loading"
            :height="$vuetify.breakpoint.mdAndDown ? '65vh' : '65vh'"
            :footer-props="{
                itemsPerPageOptions: [15, 30, 100, -1],
                itemsPerPageText: 'Work Orders Per Page',
            }"
        >
            <template v-slot:top>
                <v-row
                    no-gutter
                    class="mt-0 mx-0 pt-4 pb-0 pb-4"
                    :style="{ 'background-color': '#eeeeee' }"
                >
                    <v-col cols="12" class="d-flex mb-n3">
                        <h1 class="mr-4">WORK ORDERS</h1>
                    </v-col>
                </v-row>
            </template>
            <!--HEADERS-->
            <template v-slot:[`header.code`]="{ header }">
                <v-text-field
                    class="py-2 mt-2"
                    :label="header.text"
                    v-model="search"
                    dense
                    prepend-icon="mdi-filter"
                />
            </template>
            <template v-slot:[`header.project`]="{ header }">
                <v-text-field
                    class="py-2 mt-2"
                    :label="header.text"
                    v-model="projectToFilter"
                    dense
                    prepend-icon="mdi-filter"
                />
            </template>
            <!--ITEMS-->
            <template v-slot:[`item.order`]="{ item }">
                <div class="d-flex justify-center">
                    <p class="my-0">{{ item.order }}</p>
                </div>
            </template>
            <template v-slot:[`item.createdBy`]="{ item }">
                <div class="d-flex justify-center">
                    <p class="my-0">{{ item.createdBy.name }}</p>
                </div>
            </template>
            <template v-slot:[`item.project`]="{ item }">
                <div class="d-flex justify-center">
                    <p class="my-0">
                        {{ item.project.reference }} - {{ item.project.name }}
                    </p>
                </div>
            </template>
            <template v-slot:[`item.productionStart`]="{ item }">
                <div class="d-flex justify-center">
                    <p class="my-0">
                        {{
                            item.productionStart
                                ? formatDate(item.productionStart.seconds)
                                : ''
                        }}
                    </p>
                </div>
            </template>
            <template v-slot:[`item.productionClosed`]="{ item }">
                <div class="d-flex justify-center" v-if="item.productionClosed">
                    <p class="my-0">
                        {{ formatDate(item.productionClosed.seconds) }}
                    </p>
                </div>
            </template>
            <template v-slot:[`item.notes`]="{ item }">
                <div class="d-flex justify-center">
                    <p class="my-0">{{ item.notes }}</p>
                </div>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <div class="d-flex justify-center">
                    <v-btn small icon @click="openProcessWorkOrder(item)">
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                </div>
            </template>
        </v-data-table>
        <v-alert
            v-if="activateAlert"
            type="success"
            color="primary"
            :style="{ position: 'absolute', right: '0px', bottom: '0px' }"
        >
            <v-row no-gutters>
                <v-col cols="11">
                    <p class="my-0">{{ alertMessage }}</p>
                </v-col>
                <v-col cols="1">
                    <v-btn
                        small
                        icon
                        class="mt-n1"
                        @click="activateAlert = false"
                    >
                        <v-icon>
                            mdi-close
                        </v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </v-alert>
        <!--PROCESS WORK ORDER-->
        <v-dialog
            v-model="processWorkOrder"
            :retain-focus="false"
            persistent
            fullscreen
        >
            <ProcessWorkOrder
                v-if="processWorkOrder"
                :order="selectedOrder"
                @close="closeProcessWorkOrder"
            />
        </v-dialog>
    </div>
</template>

<script>
import moment from 'moment'
import _ from 'lodash'
import { firestore } from '@/services/firebase'
import API from '@/services/api'
import { mapGetters, mapState, mapActions, mapMutations } from 'vuex'
import WOMethods from './WOMethods.js'

export default {
    name: 'ApprovalWO',
    components: {
        ProcessWorkOrder: () =>
            import('@/components/WorkOrders/ProcessWorkOrder.vue'),
    },
    data: () => ({
        selectedOrder: undefined,
        processWorkOrder: false,
        workOrder: false,
        projectToFilter: undefined,
        projectToFilterDebounced: undefined,
        typeToFilter: undefined,
        typeToFilterDebounced: undefined,
        loading: false,
        workOrders: [],
        activateAlert: false,
        alertMessage: undefined,
        search: null,
        searchDebounced: null,
        headers: [
            {
                text: 'ORDER',
                value: 'code',
                align: 'center',
                sortable: false,
                width: '150',
            },
            {
                text: 'CREATED BY',
                value: 'createdBy',
                align: 'center',
                sortable: false,
            },
            {
                text: 'PROJECT',
                value: 'project',
                align: 'center',
                sortable: false,
            },
            {
                text: 'PRODUCTION START',
                value: 'productionStart',
                align: 'center',
                sortable: true,
            },
            {
                text: 'NOTES',
                value: 'notes',
                align: 'center',
                sortable: false,
            },
            {
                text: 'ACTIONS',
                value: 'actions',
                align: 'center',
                sortable: false,
            },
        ],
        companyId: JSON.parse(localStorage.getItem('company')),
        statusColor: {
            production: '#FFC000',
            cancelled: 'red',
            closed: 'primary',
        },
        listener: undefined,
        resourceId: undefined,
        user: {},
        users: {},
        projects: {},
        woMethods: new WOMethods(),
        pendingWoFieldSaves: {
            description: false,
            notes: false,
            localValues: {},
        },
    }),
    provide() {
        return {
            approveWO: this.approveWO,
            pendingWoFieldSaves: this.pendingWoFieldSaves,
        }
    },
    computed: {
        ...mapState(['notificationResource']),
        workOrdersFiltered() {
            this.openResource()
            let conditions = []
            if (this.searchDebounced) {
                conditions.push(this.filterOrder)
            }
            if (this.projectToFilterDebounced) {
                conditions.push(this.filterProject)
            }
            if (this.typeToFilterDebounced) {
                conditions.push(this.filterByType)
            }
            if (conditions.length > 0) {
                return this.workOrders.filter(order => {
                    return conditions.every(condition => {
                        return condition(order)
                    })
                })
            }
            this.sort()
            return this.workOrders
        },
    },
    watch: {
        notificationResource: function(resource) {
            if (resource) {
                this.resourceId = resource
                this.openResource()
                this.setNotificationResource(undefined)
            }
        },
        search: function(newValue) {
            this.debouncedSearch(newValue)
        },
        projectToFilter: function(newValue) {
            this.debouncedProjectFilter(newValue)
        },
        typeToFilter: function(newValue) {
            this.debouncedTypeFilter(newValue)
        },
    },
    created() {
        this.debouncedSearch = _.debounce(value => {
            this.searchDebounced = value
        }, 400)
        this.debouncedProjectFilter = _.debounce(value => {
            this.projectToFilterDebounced = value
        }, 400)
        this.debouncedTypeFilter = _.debounce(value => {
            this.typeToFilterDebounced = value
        }, 400)
    },
    async mounted() {
        try {
            this.loading = true
            this.resourceId = this.$route.query.resourceId
            const {
                user,
                projects,
                users,
            } = await this.woMethods.bootstrapWoLookups()
            this.user = user
            this.projects = projects
            this.users = users
            await this.getWOFromSDK()
        } catch (error) {
            this.setErrorItems({
                source: this.$options.name,
                message: error.message,
            })
        } finally {
            this.loading = false
        }
    },
    beforeDestroy() {
        if (this.listener) {
            this.listener()
            this.listener = null
        }
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        ...mapActions(['setNotificationResource']),
        ...mapGetters(['getNotificationResource']),
        async loadAllActiveWorkOrders() {
            return await this.woMethods.loadAllActiveWorkOrders(
                this.companyId,
                ['sent'],
                true,
                ['sent', 'rejected', 'approved', 'deleted']
            )
        },
        async getWOFromSDK() {
            try {
                this.loading = true

                const filterByProjectManager = !this.user.permissions.includes(
                    'readAllWO'
                )
                const projectManagerToFilter = this.user.id

                let startDate = new Date()
                let query = firestore
                    .collection('companies')
                    .doc(this.companyId)
                    .collection('workOrders')
                    .where('status', 'in', [
                        'sent',
                        'rejected',
                        'approved',
                        'deleted',
                    ])
                    .where('updatedOn', '>=', startDate)

                let initialData = await this.loadAllActiveWorkOrders()

                let data = await this.woMethods.mapInBatches(initialData, wo =>
                    this.formatWorkOrder(wo)
                )
                this.workOrders = data

                this.listener = query.onSnapshot(async snapshot => {
                    const changes = Array.from(snapshot.docChanges())
                    const processedChanges = await Promise.all(
                        changes.map(async change => {
                            let wo = Object.assign(change.doc.data(), {
                                id: change.doc.id,
                            })
                            wo = await this.formatWorkOrder(wo)
                            return { change, wo }
                        })
                    )

                    // Procesar todos los cambios después de que todos se hayan formateado
                    processedChanges.forEach(({ change, wo }) => {
                        if (wo) {
                            if (
                                change.type === 'added' ||
                                change.type === 'modified'
                            ) {
                                const index = data.findIndex(w => w.id == wo.id)
                                if (index >= 0) {
                                    // Usar $set para asegurar reactividad de Vue
                                    if (
                                        filterByProjectManager &&
                                        projectManagerToFilter
                                    ) {
                                        if (
                                            wo.projectManager ==
                                            projectManagerToFilter
                                        ) {
                                            this.$set(data, index, wo)
                                        } else {
                                            data.splice(index, 1)
                                        }
                                    } else {
                                        this.$set(data, index, wo)
                                    }
                                } else {
                                    if (
                                        filterByProjectManager &&
                                        projectManagerToFilter
                                    ) {
                                        if (
                                            wo.projectManager ==
                                            projectManagerToFilter
                                        ) {
                                            data.push(wo)
                                        }
                                    } else {
                                        data.push(wo)
                                    }
                                }
                            }
                            if (
                                change.type === 'removed' ||
                                wo.status !== 'sent'
                            ) {
                                const index = data.findIndex(w => w.id == wo.id)
                                if (index >= 0) {
                                    data.splice(index, 1)
                                }
                            }
                        }
                    })
                    // Forzar actualización del array para asegurar reactividad
                    this.workOrders = [...data]
                })
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        async formatWorkOrder(wo) {
            try {
                const workOrder = wo

                if (
                    !['sent', 'rejected', 'approved', 'deleted'].includes(
                        workOrder.status
                    )
                ) {
                    return undefined
                }

                this.woMethods.assignCreatedBy(workOrder, this.users)

                // get or fetch project
                workOrder.project = this.projects[workOrder.projectId] || {}
                if (
                    !workOrder.project ||
                    Object.keys(workOrder.project).length == 0
                ) {
                    workOrder.project = await API.getProject(
                        workOrder.projectId
                    )
                    // add project to projects object
                    this.projects[workOrder.projectId] = workOrder.project
                }

                // update selectedOrder if it's currently open
                if (
                    this.selectedOrder &&
                    this.selectedOrder.id &&
                    this.selectedOrder.id == workOrder.id
                ) {
                    let updatedOrder = this.woMethods.formatItems(workOrder)
                    if (updatedOrder) {
                        const orderCopy = _.cloneDeep(updatedOrder)
                        const pending = this.pendingWoFieldSaves
                        // Preserve local text fields while a save is still in flight
                        // so a status snapshot does not wipe unsaved/unconfirmed edits.
                        if (
                            pending.description &&
                            pending.localValues.description !== undefined
                        ) {
                            orderCopy.description =
                                pending.localValues.description
                        }
                        if (
                            pending.notes &&
                            pending.localValues.notes !== undefined
                        ) {
                            orderCopy.notes = pending.localValues.notes
                        }
                        this.selectedOrder = orderCopy
                    }
                }
                return workOrder
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            }
        },
        filterOrder(order) {
            return order.code.toLowerCase().includes(this.search.toLowerCase())
        },
        openProcessWorkOrder(item) {
            this.openProcessWorkOrderAsync(item)
        },
        async openProcessWorkOrderAsync(item) {
            try {
                this.loading = true
                let order = await this.woMethods.hydrateWorkOrderOnOpen(
                    this.companyId,
                    item
                )
                order = _.cloneDeep(order)
                order = (await this.formatWorkOrder(order)) || order
                if (order?.partNumbers) {
                    this.woMethods.formatItems(order)
                }
                this.selectedOrder = _.cloneDeep(order)
                this.processWorkOrder = true
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        closeProcessWorkOrder() {
            this.selectedOrder = {}
            this.processWorkOrder = false
            this.processWorkOrder = false
        },
        filterProject(bom) {
            return (
                bom.project.name
                    .toLowerCase()
                    .includes(this.projectToFilterDebounced.toLowerCase()) ||
                bom.project.reference
                    .toString()
                    .toLowerCase()
                    .includes(this.projectToFilterDebounced.toLowerCase())
            )
        },
        filterByType(order) {
            const type = order.assemblyWorkOrder ? 'assembly' : 'production'
            return type.includes(this.typeToFilterDebounced.toLowerCase())
        },
        formatDate(seconds) {
            return `${moment.unix(seconds).format('L')} ${moment
                .unix(seconds)
                .format('LT')}`
        },
        approveWO() {
            this.activateAlert = true
            this.alertMessage = 'WO Successfully Approved'
        },
        sort() {
            this.workOrders.sort(
                (a, b) =>
                    (b.createdOn.seconds || b.createdOn._seconds) -
                    (a.createdOn.seconds || a.createdOn._seconds)
            )
        },
        openResource() {
            if (this.resourceId) {
                const resource = this.workOrders.find(
                    w => w.id == this.resourceId
                )
                if (resource) {
                    this.resourceId = undefined
                    this.openProcessWorkOrder(resource)
                }
            }
        },
    },
}
</script>

<style></style>
